import styled from 'styled-components';

const BulletPoint = () => (
  <StyledBulletPoint>&nbsp;&bull;&nbsp;</StyledBulletPoint>
);

export const StyledBulletPoint = styled.span``;

export default BulletPoint;
